import type { Editor } from '@tiptap/react';

type EditorKey = string;

interface CachedEditor {
  editor: Editor;
  documentId?: string;
  llmRequestId?: string;
}

export const editorCache = new Map<EditorKey, CachedEditor>();

export const getCachedEditor = (key: EditorKey): CachedEditor | undefined => {
  const result = editorCache.get(key);
  return result;
};

export const setCachedEditor = (key: EditorKey, value: CachedEditor): void => {
  editorCache.set(key, value);
};

export const removeCachedEditor = (key: EditorKey): void => {
  editorCache.delete(key);
};

export const evictCachedEditor = (key: EditorKey): boolean => {
  const cached = editorCache.get(key);

  if (!cached) return false;

  const isComponentMounted = !!(cached.editor as Editor)?.storage?.documentInfo?.isComponentMounted;
  if (!isComponentMounted && !cached.editor.isDestroyed) {
    cached.editor.destroy();
  }

  editorCache.delete(key);

  return true;
};
